import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLink = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" className="icon-link" data-icon="icon-link" aria-hidden="true" {...props} ref={ref}><path d="M5.83337 5.83331H14.1667M14.1667 5.83331V14.1666M14.1667 5.83331L5.83337 14.1666" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></svg>);
});

IconLink.displayName = 'IconLink';
